import React from 'react';

import { SVGComponentProps } from './svg.types';

const AdminSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSVGProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSVGProps}
      >
        <path
          d="M7.99967 5.5C6.80634 5.5 5.83301 6.47333 5.83301 7.66667C5.83301 8.86 6.80634 9.83333 7.99967 9.83333C9.19301 9.83333 10.1663 8.86 10.1663 7.66667C10.1663 6.47333 9.19301 5.5 7.99967 5.5ZM8.66634 7.45333C8.66634 7.86 8.44634 8.24667 8.09967 8.45333L7.58634 8.76C7.50634 8.80667 7.41967 8.83333 7.32634 8.83333C7.15967 8.83333 6.99301 8.74667 6.89967 8.59333C6.75967 8.35333 6.83301 8.04667 7.07301 7.90667L7.57967 7.6C7.63301 7.56667 7.65967 7.51333 7.65967 7.46V6.84C7.65967 6.56667 7.88634 6.34 8.15967 6.34C8.43301 6.34 8.66634 6.56 8.66634 6.83333V7.45333Z"
          fill={fill}
        />
        <path
          d="M12.3595 2.78003L8.69288 1.4067C8.31288 1.2667 7.69288 1.2667 7.31288 1.4067L3.64621 2.78003C2.93954 3.0467 2.36621 3.87336 2.36621 4.6267V10.0267C2.36621 10.5667 2.71954 11.28 3.15288 11.6L6.81954 14.34C7.46621 14.8267 8.52621 14.8267 9.17288 14.34L12.8395 11.6C13.2729 11.2734 13.6262 10.5667 13.6262 10.0267V4.6267C13.6329 3.87336 13.0595 3.0467 12.3595 2.78003ZM7.99954 10.8334C6.25288 10.8334 4.83288 9.41336 4.83288 7.6667C4.83288 5.92003 6.25288 4.50003 7.99954 4.50003C9.74621 4.50003 11.1662 5.92003 11.1662 7.6667C11.1662 9.41336 9.74621 10.8334 7.99954 10.8334Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default AdminSVG;
